import React, { useEffect } from 'react';
import { HashScroll } from 'react-hash-scroll';


import Navbar from './components/navbar/navbar';
import Home from './pages/home/home';
import Contact from './pages/contact/contact';
import Maps from './pages/maps/maps';
import Therapies from './pages/therapies/therapies';
import AboutMe from './pages/aboutme/aboutme';
import Credits from './pages/credits/credits';

import Booking from './pages/booking/booking';
import Privacy from './privacy';
import Impress from './impress';


import './pages/pages.css'

import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";

const SECTION_HASH_BY_ID: Array<{ id: string; hash: string }> = [
  { id: 'home', hash: 'page-home' },
  { id: 'therapies', hash: 'page-therapies' },
  { id: 'aboutMe', hash: 'page-aboutMe' },
  { id: 'booking', hash: 'page-booking' },
  { id: 'maps', hash: 'page-maps' },
  { id: 'contact', hash: 'page-contact' },
  { id: 'credits', hash: 'page-credits' },
];

const getNavOffsetPx = () => {
  const raw = getComputedStyle(document.documentElement)
    .getPropertyValue('--nav-offset')
    .trim();
  const value = Number.parseFloat(raw);
  return Number.isFinite(value) ? value : 72;
};

const getActiveSectionHash = (navOffsetPx: number) => {
  let active = SECTION_HASH_BY_ID[0]?.hash;

  for (const section of SECTION_HASH_BY_ID) {
    const element = document.getElementById(section.id);
    if (!element) continue;

    const top = element.getBoundingClientRect().top;
    if (top - navOffsetPx <= 1) {
      active = section.hash;
      continue;
    }

    break;
  }

  return active;
};

const HashUrlSync = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.pathname !== '/') return;

    const initialHash = window.location.hash;
    const delayMs = initialHash && initialHash !== '#page-home' ? 800 : 0;
    const startedAt = Date.now();

    let ticking = false;
    const update = () => {
      ticking = false;
      if (Date.now() - startedAt < delayMs) return;

      const navOffsetPx = getNavOffsetPx();
      const activeHash = getActiveSectionHash(navOffsetPx);
      if (!activeHash) return;

      const nextHash = `#${activeHash}`;
      if (window.location.hash === nextHash) return;

      const nextUrl = `${window.location.pathname}${window.location.search}${nextHash}`;
      window.history.replaceState(null, '', nextUrl);
    };

    const onScrollOrResize = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    };

    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize);
    onScrollOrResize();

    return () => {
      window.removeEventListener('scroll', onScrollOrResize);
      window.removeEventListener('resize', onScrollOrResize);
    };
  }, [location.pathname]);

  return null;
};

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={
          <div>
            <Navbar />
            <HashUrlSync />
            <HashScroll hash={'page-home'} position="start"><div className="hashScrollTarget"><Home /></div></HashScroll>

            <div className="background">
              <HashScroll behavior={"smooth"} position="start" hash={'page-therapies'}><div className="hashScrollTarget"><Therapies /></div></HashScroll>
              <HashScroll behavior={"smooth"} position="start" hash={'page-aboutMe'}><div className="hashScrollTarget"><AboutMe /></div></HashScroll>
              <HashScroll behavior={"smooth"} position="start" hash={'page-booking'}><div className="hashScrollTarget"><Booking /></div></HashScroll>
              <HashScroll behavior={"smooth"} position="start" hash={'page-maps'}><div className="hashScrollTarget"><Maps /></div></HashScroll>
              <HashScroll behavior={"smooth"} position="start" hash={'page-contact'}><div className="hashScrollTarget"><Contact /></div></HashScroll>
              <HashScroll behavior={"smooth"} position="start" hash={'page-credits'}><div className="hashScrollTarget"><Credits /></div></HashScroll>

            </div>
          </div>
        }>
        </ Route>
        <Route path="booking" element={<Navigate to="/#page-booking" replace />} />
        <Route path="Mein-Termin" element={<Navigate to="/#page-booking" replace />} />
        <Route path="privacy" element={<Privacy />} />
        <Route path="impress" element={<Impress />} />

      </Routes>
    </BrowserRouter>

  )
}
export default App;